import React from 'react';
import { Text } from '@livechat/design-system-react-components';

import Amplitude from 'modules/Amplitude';
import Location from 'modules/Location';

import { ErrorMessageForm } from '../forms/error-message-form/ErrorMessageForm';

import * as styles from './styles';

interface IProps {
  requestId?: string;
  traceId?: string;
  description?: string;
  exceptionDetails?: string;
  oauthException?: string;
}

export const UnexpectedError: React.FC<IProps> = ({
  requestId = '',
  traceId,
  description = '',
  exceptionDetails = '',
  oauthException,
}) => {
  Amplitude.logEvent(null, 'ERROR_PAGE_DISPLAYED', {
    requestOrTraceId: requestId || traceId,
    message: description,
    exceptionDetails,
    queryParams: window.location.search,
    clientId: Location.getUrlParam('client_id'),
    redirectUri: Location.getUrlParam('redirect_uri'),
    responseType: Location.getUrlParam('response_type'),
  });

  const isScopeInvalid = oauthException === 'invalid_scope';
  const titleCaption = isScopeInvalid ? `Access restricted` : 'Something went wrong';

  return (
    <ErrorMessageForm
      titleCaption={titleCaption}
      titleContent={
        isScopeInvalid ? (
          <Text>
            You can’t view this page because your role doesn’t allow it or you don’t have access to
            this product.
          </Text>
        ) : (
          <Text>
            Sorry, there was an unexpected problem:
            <br />
            {description}
            <br />
            {exceptionDetails}
          </Text>
        )
      }
      isUnknown
      backToLogin
    >
      <div css={styles.requestIDContainer}>
        <Text size="sm" bold>
          Send this ID to help us identify the problem
        </Text>
        <Text size="sm">{requestId || traceId}</Text>
      </div>
    </ErrorMessageForm>
  );
};
